import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderSimpleButtonGroup } from '../../views/SimpleButtonGroup';
import { buildAnswers, buildUserAnswerMessage } from '../utils';

const SECTION_KEY_NAME = 'wallConstructionType';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'constructionType';

export const wallConstructionTypeSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: BaseAnswerType[] = [
    { value: '塗装', textContents: '塗装' },
    { value: '張り替え', textContents: '張り替え' },
    { value: '決まっていない', textContents: (<>決まって<br />いない</>) },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '外壁の工事種別は',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        外壁の工事内容はお決まりでしょうか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
